import { ContextMenuIcon } from 'features/common/ui/ContextMenu'
import MoreIcon from 'assets/icons/icon-navigation-more-vert.svg?react'
import { useCallback, useMemo } from 'react'
import { useTheme } from '@mui/material'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import { IntegrationPaths } from '../../paths'
import { createDialogOpener } from 'features/dialogs/openDialog'

const openIntegrationBucketDeleteDialog = createDialogOpener(() => import('./WorkloadIdentityFederationDeleteDialog'))

function WorkloadIdentityFederationContextMenu() {
  const theme = useTheme()
  const intl = useIntl()
  const navigate = useNavigate()

  const onClickMenuItem = useCallback(
    ({ id }) => {
      switch (id) {
        case 'edit':
          navigate(IntegrationPaths.WorkloadIdentityFederation())
          break
        case 'delete':
          openIntegrationBucketDeleteDialog()
          break
        default:
      }
    },
    [navigate]
  )

  const actions = useMemo(
    () => [
      {
        id: 'edit',
        label: intl.formatMessage({ id: 'integrations.redshift.contextMenu.edit' })
      },
      {
        id: 'delete',
        label: intl.formatMessage({ id: 'common.actions.delete' }),
        destructive: true,
        divider: true
      }
    ],
    [intl]
  )

  return (
    <>
      <ContextMenuIcon
        aria-label="Integrations actions"
        menuItems={actions}
        placement="bottom-end"
        onClickItem={onClickMenuItem}
        alignRight={true}
      >
        <MoreIcon fill={theme.palette.text.secondary} />
      </ContextMenuIcon>
    </>
  )
}

export default WorkloadIdentityFederationContextMenu
